import { render, staticRenderFns } from "./AgendamentoProfessor.vue?vue&type=template&id=e4f9150c"
import script from "./AgendamentoProfessor.vue?vue&type=script&lang=js"
export * from "./AgendamentoProfessor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports